
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) Otwórz menu przeglądarki`,
's182ab2d6c997515f': `Dodaj do swojego Ekranu Głównego, aby uzyskać bogate doświadczenie i łatwy dostęp.`,
's1b9047d53d9f9d22': `2) Wybierz "Udostępnij"`,
's2d90afa5dcca2c0e': `3) Przewiń w dół do opcji "Dodaj do Ekranu Głównego"`,
's37a9e8aec5713460': `Więcej`,
's4593f304dac8848c': `2) Naciśnij "Dodaj do Ekranu Głównego"`,
's54cfbb14f46396d4': `1) Otwórz w swojej głównej przeglądarce`,
's6196153c4b0c1ea0': `Zainstaluj`,
's922329d6f6213590': `Dodaj do Docka`,
'sa5ef80b4bb9b39f8': `Mniej`,
'sa7551383d1897fcc': `2) Wybierz "Dodaj do Docka"`,
'sba52286c21552a4e': `Zainstaluj na swoim urządzeniu, aby uzyskać bogate doświadczenie i łatwy dostęp.`,
'sc79fd7641eb9a975': `Ukryj instrukcję`,
'scdaf4bbff76674c8': `Dodaj do Ekranu Głównego`,
'se740f75b95a51807': `Dodaj do swojego Docka, aby uzyskać bogate doświadczenie i łatwy dostęp.`,
'sfea652f6580ff086': `Ta strona posiada funkcje aplikacji.`,
    };
  